import {destroyCookie, setCookie} from 'nookies'

export const deleteCookieClient = (key: string) => {
  destroyCookie(null, key, {path: '/'})
}

export const createCookie = (name: string, value: string) => {
  setCookie(null, name, value, {path: '/'})
}
